import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { RapportState } from './state';

export const getters: GetterTree<RapportState, RootState> = {
    getRapportItems(state){
        return state.documentReglementaire;
    },
    getRapportFilterSite(state): Array<number> {
        return state.filterSite;
    },
    getRapportFilterGroupe(state): Array<number> {
        return state.filterGroupe;
    },
    getRapportFilterSousGroupe(state): Array<number> {
        return state.filterSousGroupe;
    },
    getRapportFilterEquipement(state): Array<number> {
        return state.filterEquipement;
    },
    getRapportFilterDocumentDateFrom(state): string {
        return state.filterDocumentDateFrom;
    },
    getRapportFilterDocumentDateTo(state): string {
        return state.filterDocumentDateTo;
    },
    getRapportPage(state) {
        return state.page;
    },
    getRapportNbOfPages(state) {
        return state.nbOfPages;
    },
    getRapportScroll(state) {
        return state.scroll;
    },
    getRapportSort(state) {
        return state.sort;
    },
    getRapportCount(state) {
        return state.count;
    },
    getRapportTableHeader(state) {
        return state.tableHeader;
    },
    getRapportIsLoading(state) {
        return state.isLoading;
    },
    getZipIsLoading(state) {
        return state.isZipLoading;
    },
    getNbRapports(state) {
        return state.nbRapports;
    },
};
